import { Divider } from "@/components/ui/Divider";
import type { HomeownerUser } from "@/hooks/queries/useMe";
import { isMobile } from "@/utils/is-mobile";
import NavLink from "@/pages/homepage/components/common/NavLink";
import AccountLinksList from "./AccountLinksList";
import MobileNavLinks from "./MobileNavLinks";

export default function HomeownerMobileDrawerContent({
  user,
  onClose,
}: HomeownerMobileDrawerContentProps) {
  const isMobileView = isMobile();

  return (
    <div className="flex flex-col gap-2 pb-6">
      {isMobileView && (
        <>
          <MobileNavLinks />
          <Divider className="bg-default-200" />
          <NavLink href="/">Start a New Project</NavLink>
        </>
      )}

      <AccountLinksList
        links={user.accountLinks}
        onClose={onClose}
        isHomeowner={true}
      />
    </div>
  );
}

interface HomeownerMobileDrawerContentProps {
  user: HomeownerUser;
  onClose: () => void;
}
